<template>
  <v-container fluid>
    <template>
      <v-card>
        <v-card-title>
          <h2>
            <v-btn
              depressed
              class="mx-2"
              fab
              small
              :to="{ name: 'ordem-medicao-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <template>
              <span v-if="tituloNovo">Novo Cadastro</span>
              <span v-else>Alterar Cadastro</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-tabs v-model="tabs" grow>
            <v-tab>
              <v-icon
                left
                color="error"
                v-if="$v.$invalid"
                class="mdi mdi-alert-circle"
              ></v-icon>
              <span>Geral</span>
            </v-tab>
            <v-tab>
              <v-icon
                left
                color="error"
                v-if="$v.$invalid"
                class="mdi mdi-alert-circle"
              ></v-icon>
              <span>Faturamento</span>
            </v-tab>
            <v-tab>Documentos</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card-text>
                <v-autocomplete
                  :items="clientes"
                  :error-messages="clientesErrors"
                  label="Cliente"
                  item-value="id"
                  item-text="nome"
                  placeholder="Digite para pesquisar"
                  v-model="id_cliente"
                  :search-input.sync="search"
                  no-filter
                  :loading="isLoading"
                  required
                  @input="$v.clientes.$touch()"
                  @blur="$v.clientes.$touch()"
                  @change="(event) => onChange(event, clientes)"
                  
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ documentoCliente(item) }} {{ item.nome }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.razao_social }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Representante: {{ item.vendedor.nome }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ documentoCliente(item) }} {{ item.nome }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.razao_social }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Representante: {{ item.vendedor.nome }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>

                <template v-if="habilitaCriarVendedor && this.id == ''">
                  <v-switch v-model="criarVendedor" label="Criar OM para o representante" />
                </template>

                <v-text-field
                  v-model="localReferencia"
                  :error-messages="localReferenciaErrors"
                  :counter="100"
                  label="Local Referência"
                  required
                  @input="$v.localReferencia.$touch()"
                  @blur="$v.localReferencia.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="percentualComissao"
                  v-mask="'decimal2'"
                  :error-messages="percentualComissaoErrors"
                  :counter="6"
                  maxlength="6"
                  suffix="%"
                  label="Percentual Comissão"
                  :disabled="habilitaComissao"
                  @input="$v.percentualComissao.$touch()"
                  @blur="$v.percentualComissao.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model="descontoGeral"
                  v-mask="'decimal2'"
                  :counter="10"
                  maxlength="10"
                  label="Desconto OM R$"
                  :disabled="habilitaDesconto"
                ></v-text-field>

                <v-textarea
                  counter
                  clearable
                  clear-icon="mdi-close-circle"
                  rows="2"
                  auto-grow
                  v-model="observacaoCliente"
                  :error-messages="observacaoClienteErrors"
                  label="Observação (Essa informação será enviada ao cliente)"
                  @input="$v.observacaoCliente.$touch()"
                  @blur="$v.observacaoCliente.$touch()"
                ></v-textarea>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-radio-group v-model="rdgFormaFaturamento">
                  <v-radio label="Fat. de Locação 100%" value="T"></v-radio>
                  <v-radio label="Fat. de Locação Parcial" value="P"></v-radio>
                  <v-radio label="N. Fiscal Serviço" value="S"></v-radio>
                </v-radio-group>

                <template v-if="fatParcial">
                  <v-text-field
                    v-model="percentualFatura"
                    v-mask="'decimal2'"
                    :error-messages="percentualFaturaErrors"
                    :counter="6"
                    max-length="6"
                    suffix="%"
                    label="Percentual Fatura (%)"
                    @input="$v.percentualFatura.$touch()"
                    @blur="$v.percentualFatura.$touch()"
                  ></v-text-field>
                  <v-text-field
                    v-model="percentualNotaFiscal"
                    v-mask="'decimal2'"
                    :error-messages="percentualNotaFiscalErrors"
                    :counter="6"
                    maxlength="6"
                    label="Percentual NF (%)"
                    suffix="%"
                    @input="$v.percentualNotaFiscal.$touch()"
                    @blur="$v.percentualNotaFiscal.$touch()"
                  ></v-text-field>
                </template>

                <template v-if="fatServico">
                  <v-text-field
                    v-model="percentualEquipamento"
                    v-mask="'decimal2'"
                    :error-messages="percentualEquipamentoErrors"
                    :counter="6"
                    maxlength="6"
                    suffix="%"
                    label="Percentual Equipamento (%)"
                    @input="$v.percentualEquipamento.$touch()"
                    @blur="$v.percentualEquipamento.$touch()"
                  ></v-text-field>
                  <v-text-field
                    v-model="percentualMaoObra"
                    v-mask="'decimal2'"
                    :error-messages="percentualMaoObraErrors"
                    :counter="6"
                    maxlength="6"
                    suffix="%"
                    label="Percentual M. Obra (%)"
                    @input="$v.percentualMaoObra.$touch()"
                    @blur="$v.percentualMaoObra.$touch()"
                  ></v-text-field>
                </template>

                <h3 class="headline font-weight-thin mt-2">
                  Faturar pela CD se:
                </h3>
                <v-checkbox
                  v-model="chkFaturaAntecipada"
                  :label="'Faturamento Antecipado'"
                ></v-checkbox>
                <v-checkbox
                  v-model="chkSinistroObra"
                  :label="'Houve Sinistro/Acidente'"
                ></v-checkbox>
                <v-checkbox
                  v-model="chkContratoSeguro"
                  :label="'Houve Contratação Seguro'"
                ></v-checkbox>
                <v-checkbox
                  v-model="chkCadastroAntecipadoCliente"
                  :label="'Cadastro Antecipado no Cliente'"
                ></v-checkbox>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <lista-documentos
                url-base="ordem"
                :id-proprietario="id"
                v-model="documentos"
                alterar
              />
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import ListaDocumentos from "../components/documentos/ListaDocumentos";
import _ from "lodash";
import { build, unmaskDecimal } from "../lib/masks";

export default {
  components: { ListaDocumentos },
  mixins: [validationMixin],

  validations: {
    localReferencia: { required, maxLength: maxLength(100) },
    clientes: { required },
    percentualFatura: { maxLength: maxLength(6) },
    percentualNotaFiscal: { maxLength: maxLength(6) },
    percentualEquipamento: { maxLength: maxLength(6) },
    percentualMaoObra: { maxLength: maxLength(6) },
    percentualComissao: { maxLength: maxLength(6) },
    observacaoCliente: { maxLength: maxLength(300) },
  },

  data() {
    return {
      id: "",
      id_cliente: "",
      localReferencia: "",
      percentualFatura: "",
      percentualNotaFiscal: "",
      percentualEquipamento: "",
      percentualMaoObra: "",
      percentualComissao: 5,
      chkFaturaAntecipada: false,
      chkSinistroObra: false,
      chkContratoSeguro: false,
      chkCadastroAntecipadoCliente: false,
      habilitaComissao: true,
      habilitaCriarVendedor: false,
      habilitaDesconto: true,
      descontoGeral: "",
      observacaoCliente: "",


      rdgFormaFaturamento: "T",

      situacao: "A",

      fatParcial: false,
      fatServico: false,

      criarVendedor: false,
      id_vendedor: "",

      tituloNovo: true,
      select: null,
      tabs: null,
      documentos: [],

      isLoading: false,
      model: null,
      search: null,
      clientes: [],

      menu: false,
    };
  },

  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
    localReferenciaErrors() {
      const errors = [];
      if (!this.$v.localReferencia.$dirty) return errors;
      !this.$v.localReferencia.required &&
        errors.push("Local de Referência é Obrigatório.");
      !this.$v.localReferencia.maxLength &&
        errors.push("Somente 100 caracteres.");

      return errors;
    },
    clientesErrors() {
      const errors = [];
      if (!this.$v.clientes.$dirty) return errors;
      !this.$v.clientes.required && errors.push("Campo é Obrigatório.");
      return errors;
    },
    observacaoClienteErrors() {
      const errors = [];
      if (!this.$v.observacaoCliente.$dirty) return errors;
      !this.$v.observacaoCliente.maxLength && errors.push("Somente 300 caracteres.");

      return errors;
    },
    percentualFaturaErrors() {
      const errors = [];
      if (!this.$v.percentualFatura.$dirty) return errors;
      !this.$v.percentualFatura.maxLength &&
        errors.push("Somente 5 caracteres.");

      return errors;
    },
    percentualNotaFiscalErrors() {
      const errors = [];
      if (!this.$v.percentualNotaFiscal.$dirty) return errors;
      !this.$v.percentualNotaFiscal.maxLength &&
        errors.push("Somente 5 caracteres.");

      return errors;
    },
    percentualEquipamentoErrors() {
      const errors = [];
      if (!this.$v.percentualEquipamento.$dirty) return errors;
      !this.$v.percentualEquipamento.maxLength &&
        errors.push("Somente 5 caracteres.");

      return errors;
    },
    percentualMaoObraErrors() {
      const errors = [];
      if (!this.$v.percentualMaoObra.$dirty) return errors;
      !this.$v.percentualMaoObra.maxLength &&
        errors.push("Somente 5 caracteres.");

      return errors;
    },
    percentualComissaoErrors() {
      const errors = [];
      if (!this.$v.percentualComissao.$dirty) return errors;
      !this.$v.percentualComissao.maxLength &&
        errors.push("Somente 5 caracteres.");

      return errors;
    },
  },
  watch: {
    search: _.debounce(function(val) {
      if (val) {
        this.buscarClientes(val);
      }
    }, 500),
    rdgFormaFaturamento(val) {
      if (val == "T") {
        this.fatParcial = false;
        this.fatServico = false;
      } else if (val == "P") {
        this.fatParcial = true;
        this.fatServico = false;
      } else if (val == "S") {
        this.fatParcial = false;
        this.fatServico = true;
      }
    },
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        try {

          let id_usuario_emissao = this.$store.state.usuarios.usuarioAtivo.id;
          if(this.criarVendedor){
              id_usuario_emissao = this.id_vendedor;
          }
          const ordem = await this.$store.dispatch("ordemMedicao/gravar", {
            id: this.id,
            id_cliente: this.id_cliente,
            local_referencia: this.localReferencia,

            forma_faturamento: this.rdgFormaFaturamento,
            percentual_fatura: parseFloat(unmaskDecimal(this.percentualFatura)),
            percentual_nota_fiscal: parseFloat(
              unmaskDecimal(this.percentualNotaFiscal)
            ),
            percentual_equipamento: parseFloat(
              unmaskDecimal(this.percentualEquipamento)
            ),
            percentual_mao_obra: parseFloat(
              unmaskDecimal(this.percentualMaoObra)
            ),
            percentual_comissao: parseFloat(
              unmaskDecimal(this.percentualComissao)
            ),
            faturamento_antecipado: this.chkFaturaAntecipada,
            sinistro: this.chkSinistroObra,
            seguro: this.chkContratoSeguro,
            cadastro_antecipado: this.chkCadastroAntecipadoCliente,

            id_usuario_emissao: id_usuario_emissao,
            data_emissao: new Date(),

            situacao: this.situacao,

            observacao_cliente: this.observacaoCliente,

            desconto: parseFloat(unmaskDecimal(this.descontoGeral)),
          });
          if (this.documentos.length > 0) {
            await this.$store.dispatch("documento/gravar", {
              urlBase: "ordem",
              IDProprietario: ordem.id,
              documentos: this.documentos,
            });
          }
          this.$router.replace({ path: "lista", name: "ordem-medicao-list" });
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível salvar a Ordem de Medição",
          });
        }
      }
    },
    onChange(e,items){
      for (let item of Array.from(items)) {
        if(item.id == this.id_cliente){
          this.id_vendedor = item.vendedor.id_usuario;
        }
      }
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async buscarClientes(val) {
      if (val.length >= 2) {
        if (this.isLoading) return;

        this.isLoading = true;

        try {
          var response = await this.$store.dispatch(
            "ordemMedicao/carregarClientes",
            { pesquisa: val,carregarVendedor: true ,filtros: { ativo: true} }
          );
          this.clientes = response.clientes;

          this.isLoading = false;
        } catch (err) {
          this.isLoading = false;
        }
      } else {
        this.clientes = [];
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    DataSql(dataBR) {
      if (!dataBR) return null;

      const [day, month, year] = dataBR.split("/");
      return `${year}-${month}-${day}T00:00:00Z`;
    },
    DataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.split("-");
      return `${day}/${month}/${year}`;
    },
    documentoCliente(cliente) {
      if (cliente.tipo == "F") {
        return "CPF: " + build.cpf(cliente.cpf_cnpj);
      }
      return "CNPJ: " + build.cnpj(cliente.cpf_cnpj);
    },
  },
  async mounted() {
    //this.preloader = true;
    this.id = "";
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "ordemMedicao/carregarOrdemMedicao",
          id
        );
        //console.log(response);
        this.codigo = response.data.codigo;
        this.id_cliente = response.data.id_cliente;
        this.localReferencia = response.data.local_referencia;

        this.rdgFormaFaturamento = response.data.forma_faturamento;
        this.percentualFatura = response.data.percentual_fatura;
        this.percentualNotaFiscal = response.data.percentual_nota_fiscal;
        this.percentualEquipamento = response.data.percentual_equipamento;
        this.percentualMaoObra = response.data.percentual_mao_obra;
        this.percentualComissao = response.data.percentual_comissao;
        this.chkFaturaAntecipada = response.data.faturamento_antecipado;
        this.chkSinistroObra = response.data.sinistro;
        this.chkContratoSeguro = response.data.seguro;
        this.chkCadastroAntecipadoCliente = response.data.cadastro_antecipado;
        this.situacao = response.data.situacao;
        this.descontoGeral = response.data.desconto;
        this.observacaoCliente = response.data.observacao_cliente;

        this.clientes = [response.data.cliente];

        //this.preloader = false;
      } catch (err) {
        //deu pau
      }
    }

    if (this.perms.includes("ordemmedicao.alterar_comissao")) {
      this.habilitaComissao = false;
    }
    if (this.perms.includes("ordemmedicao.alterar_desconto")) {
      this.habilitaDesconto = false;
    }
    if (this.perms.includes("cliente.listar_todos")) {
      this.habilitaCriarVendedor = true;
    }
  },
};
</script>
